require('./lbAgentChatWidget.scss');

const $inject = [];
const lbAgentChatWidget = function () {
  return {
    controller: 'lbAgentChatWidgetCtrl',
    controllerAs: 'vm',
    bindToController: true,
    template: require('./lbAgentChatWidget.html'),
  };
};

lbAgentChatWidget.$inject = $inject;

export default lbAgentChatWidget;



// WEBPACK FOOTER //
// ./src/components/lbAgentChatWidget/lbAgentChatWidgetDir.js